import { render, staticRenderFns } from "./BrandsList.vue?vue&type=template&id=322fef46&scoped=true&"
import script from "./BrandsList.vue?vue&type=script&lang=js&"
export * from "./BrandsList.vue?vue&type=script&lang=js&"
import style0 from "./BrandsList.vue?vue&type=style&index=0&id=322fef46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322fef46",
  null
  
)

export default component.exports